import { useEffect } from "react";
import { format } from "date-fns";
import useCourtReservation from "./useCourtReservation";
import { SaleStep } from "../../../../store/stepSaleConfig/stepSaleConfigReducer";

interface UseCourtReservationModalProps {
  isOpen: boolean;
  exerciseId: number | null;
  saleStep: SaleStep;
}

export default function useCourtReservationModal({ isOpen, exerciseId, saleStep }: UseCourtReservationModalProps) {
  const { tickets, exerciseDetails, loading, ticketAccess, ticketLimit, getReservationData, resetData } =
    useCourtReservation();

  const allowToSignByPass = saleStep?.allowToSignByPass || false;

  useEffect(() => {
    if (isOpen && exerciseId) {
      getReservationData(exerciseId);
    } else if (!isOpen) {
      resetData();
    }
  }, [isOpen, exerciseId, getReservationData, resetData]);

  const getModalTitle = () => {
    if (!exerciseDetails) return "Rezerwacja";
    const startTime = format(exerciseDetails.startTime, "HH:mm");
    return `Rezerwacja: ${exerciseDetails.name}, godz: ${startTime}`;
  };

  const getCapacityText = () => {
    if (!exerciseDetails) return "";
    return `${exerciseDetails.reserved + exerciseDetails.prereservation}/${exerciseDetails.capacity}`;
  };

  const getBuyButtonTitle = () => {
    // const minPrice = getMinPrice();
    return `Kup wejście`;
  };

  const isSaleAvailable = () => {
    if (!exerciseDetails) return true;

    const now = Date.now();
    const { saleFrom, saleTo } = exerciseDetails;

    return now >= saleFrom && now <= saleTo;
  };

  const getSaleUnavailableMessage = () => {
    if (!exerciseDetails) return "";

    const now = Date.now();
    const { saleFrom, saleTo } = exerciseDetails;

    if (now < saleFrom) {
      return "Sprzedaż jeszcze się nie rozpoczęła";
    }

    if (now > saleTo) {
      return "Sprzedaż została zakończona";
    }

    return "";
  };

  return {
    tickets,
    exerciseDetails,
    loading,
    ticketAccess,
    ticketLimit,
    allowToSignByPass,
    getModalTitle,
    getCapacityText,
    getBuyButtonTitle,
    isSaleAvailable,
    getSaleUnavailableMessage,
  };
}
